import Vue from 'vue'
import router from '../router'
import carregarArquivoLaudo from './xlsx/laudo'
import pdfMake, { styles, pageConfig } from '@/plugins/pdf'
import { laudo as routing, pendencia } from '../util/routes'

export default {
  state: {
    laudo: {},
    laudos: [],
    paginateLaudos: {
      data: []
    },
    laudoPage: 1,
    laudoFilter: ''
  },
  mutations: {
    setLaudo: (state, payload) => {
      state.laudo = payload
    },
    setLaudos: (state, payload) => {
      state.laudos = payload
    },
    setPaginateLaudos: (state, payload) => {
      state.paginateLaudos = payload
    },
    setLaudoPage: (state, payload = 1) => {
      state.laudoPage = payload
    },
    setLaudoFilter: (state, payload = '') => {
      state.laudoFilter = payload
    }
  },
  actions: {
    async getPaginateLaudos ({ state, commit }, payload) {
      commit('setPaginateLaudos', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.laudoPage,
          filter: state.laudoFilter
        }
      })
      commit('setPaginateLaudos', data)
    },
    async getLaudosToPrintAnexoIVFull ({ commit }, payload) {
      commit('setLaudos', {})
      const { data } = await Vue.axios.get(`${routing}/anexo-iv`, {
        headers: {
          ...payload
        }
      })
      commit('setLaudos', data)
    },
    async getLaudos ({ commit }, payload) {
      commit('setLaudos', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0,
          ...payload
        }
      })
      commit('setLaudos', data)
    },
    async getLaudo ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setLaudo', data)
    },
    async postSaveLaudo ({ state }) {
      const { laudo } = state
      if (laudo.id) {
        return Vue.axios.put(`${routing}/${laudo.id}`, laudo)
      }
      return Vue.axios.post(`${routing}`, laudo)
    },
    async deleteLaudo ({ state }) {
      const { laudo } = state
      return Vue.axios.delete(`${routing}/${laudo.id}`)
    },
    async carregarMultiplosLaudos ({ commit, state }, { file, industria }) {
      return carregarArquivoLaudo(file, async laudos => {
        await Vue.axios
          .post(`${routing}/import/${industria}`, { laudos })
          .then(() => {
            alert('Laudos importado com sucesso.')
            return router.push({
              name: 'laudos-index'
            })
          })
          .catch(error => {
            console.error(error)
            return alert('Ocorreu um erro durante a importação dos laudos.')
          })
      })
    },
    async printLaudosAnexoIVFull ({ commit, state }, { laudos }) {
      await Vue.axios
        .post(`documentos/laudos/anexo-ix/completo`, { laudos })
        .then(({ data: content }) => {
          const docDefinition = {
            ...pageConfig,
            styles,
            content
          }
          return pdfMake.createPdf(docDefinition).open()
        })
        .catch(error => {
          alert(
            `Ocorreu um erro durante o processamento dos laudos para impressão => ${error.data.error.message} [${error.data.error.status}]`
          )
          return console.error(error)
        })
    },
    async getPendenciasLaudos ({ commit }, payload) {
      commit('setLaudos', Object.assign({}, {}))
      const response = await Vue.axios.get(`${pendencia}/laudos`)
      commit('setLaudos', response.data)
    }
  },
  getters: {
    laudo: ({ laudo }) => laudo,
    laudoPage: ({ laudoPage }) => laudoPage,
    laudoFilter: ({ laudoFilter }) => laudoFilter,
    laudos: ({ laudos }) => laudos,
    paginateLaudos: ({ paginateLaudos }) => paginateLaudos,
    paginateLaudosStatus: ({ paginateLaudosStatus }) => paginateLaudosStatus
  }
}
